import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  Checkbox,
  CheckboxPropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/checkbox.scss';

export type NcCheckboxT = React.FC<CheckboxPropsT>;

export const NcCheckbox: NcCheckboxT = ({ className, ...props }) => {
  const classNames = mergeClassNameStrings('nc-checkbox', className);

  return <Checkbox className={classNames} {...props} />;
};
